import styled from "@emotion/styled"

export const MainContainer = styled.div`
  background: linear-gradient(to right, #ec167f, #883ff9);
  background: #000;
  padding: 50px 0px;
  margin-bottom: 10px;
  @media (max-width: 560px) {
    padding: 80px 0px;
  }
`

export const InnerContainer = styled.div`
  width: 80%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(188px, 1fr));
  grid-gap: 44px;
  @media (max-width: 560px) {
    grid-gap: 95px;
  }
`

export const Text = styled.div`
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(
    45deg,
    #405de6,
    #5851db,
    #833ab4,
    #c13584,
    #e1306c,
    #fd1d1d
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 60px;
`

export const Number = styled.div`
  font-size: 72px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(to right, #30cfd0 0%, #330867 100%);
  /* background: linear-gradient(
    45deg,
    #405de6,
    #5851db,
    #833ab4,
    #c13584,
    #e1306c,
    #fd1d1d
  ); */
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 60px;
`

export const Block = styled.div`
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;

  /* background: #000; */
  /* background: linear-gradient(
    45deg,
    #405de6,
    #5851db,
    #833ab4,
    #c13584,
    #e1306c,
    #fd1d1d
  ); */
  height: 100px;
  margin: auto;
  /* border: 1px solid red; */
  @media (max-width: 560px) {
    align-items: center;
  }
`
